import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import getBusinessName from "../common/Business";

class LinkedInDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    };
  }
  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  openwindow = url => window.open(url, "_blank");

  render() {
    const rows = [];
    if (this.props.node !== undefined && this.props.node.length > 0) {
      _.forEach(this.props.node, (profile, index) => {
        const name = `${_.get(profile, "firstName[0]._", "")} ${_.get(
          profile,
          "lastName[0]._",
          ""
        )}`;
        rows.push(
          <Table.Row key={`url_row_${index}`}>
            <Table.Cell>
              <span className="text-bold">Name:</span>
            </Table.Cell>
            <Table.Cell>
              <a
                target={"_blank"}
                rel={"noopener noreferrer"}
                href={`${_.get(profile, "profile_url[0]._", "")}`}
              >
                {name}
              </a>
            </Table.Cell>
            <Table.Cell>
              <span className="text-bold">Headline:</span>
            </Table.Cell>
            <Table.Cell>{_.get(profile, "headline[0]._")}</Table.Cell>
          </Table.Row>
        );
        rows.push(
          <Table.Row key={`link_location_row_${index}`}>
            <Table.Cell>
              <span className="text-bold">Location:</span>
            </Table.Cell>
            <Table.Cell>{_.get(profile, "location[0]._")}</Table.Cell>
            <Table.Cell>
              <span className="text-bold">Industry:</span>
            </Table.Cell>
            <Table.Cell>{_.get(profile, "industry[0]._")}</Table.Cell>
          </Table.Row>
        );
        const companyRows = [];
        const companyNodes = _.get(profile, "employments[0].company");
        if (companyNodes !== undefined) {
          _.forEach(companyNodes, (companyNode, compIndex) => {
            companyRows.push(
              <Table.Row key={`link_comapny_row_${index}_${compIndex}`}>
                <Table.Cell>
                  <span className="text-bold">Company:</span>
                </Table.Cell>
                <Table.Cell>
                  {getBusinessName(
                    _.get(profile, "company_name[0]._"),
                    this.props
                  )}
                </Table.Cell>
                <Table.Cell>
                  <span className="text-bold">Designation:</span>
                </Table.Cell>
                <Table.Cell>{_.get(profile, "designation[0]._")}</Table.Cell>
              </Table.Row>
            );
          });
        }
        rows.push(
          <Table.Row key={`link_company_table_row_${index}`}>
            <Table.Cell>
              <Table>
                <Table.Body>{companyRows}</Table.Body>
              </Table>
            </Table.Cell>
          </Table.Row>
        );
      });
    } else {
      rows.push(
        <Table.Row>
          <Table.Cell>No Records Found</Table.Cell>
        </Table.Row>
      );
    }

    return (
      <Accordion fluid styled>
        <Accordion.Title
          active={this.state.activeIndex === 0}
          key={`LinkedInTitle`}
          onClick={() => this.handleClick()}
        >
          <p>LinkedIn</p>
        </Accordion.Title>
        <Accordion.Content
          key={`LinkedInBody`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>{rows}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}
export default LinkedInDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/LinkedInDetail.js